import { FC } from "react";
import { Center, Spinner } from "@chakra-ui/react";

export const SbpTransferPageContentPending: FC = () => {
  return (
    <Center flex="1" pb="100px">
      <Spinner />
    </Center>
  );
};
